import * as THREE from 'three'
import Experience from './Experience.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.cameraPosition = 60

        this.setInstance()
        this.setControls()
    }

    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(20, this.sizes.width / this.sizes.height, 0.1, 100)
        this.instance.position.set(0, 0, this.cameraPosition)
        this.scene.add(this.instance)
        
    }

    setControls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)
        // this.controls = new OrbitControls(this.instance, document.body)
        // this.controls.enabled = false
        this.controls.enableZoom = false
        this.controls.target.set(0, 0, 0)
        this.controls.enableDamping = true
        this.controls.enableRotate = false;
        this.controls.enablePan = false
        this.controls.autoRotateSpeed = 0.5
        // this.controls.mouseButtons = {
        //     LEFT: THREE.MOUSE.PAN
        // }
        // this.controls.touches = {
        //     ONE: THREE.TOUCH.DOLLY_PAN
        // }
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        this.controls.update()
    }
}